export enum eLinkType {
    Ordinary = 'ordinary',
    Tel = 'tel',
    Mailto = 'mailto',
}